/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IBosonAccountHandler,
  IBosonAccountHandlerInterface,
} from "../IBosonAccountHandler";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "agentId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "feePercentage",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "wallet",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.Agent",
        name: "agent",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "AgentCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "agentId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "feePercentage",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "wallet",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.Agent",
        name: "agent",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "AgentUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "disputeResolverId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "addedSellers",
        type: "uint256[]",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "AllowedSellersAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "disputeResolverId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "removedSellers",
        type: "uint256[]",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "AllowedSellersRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "buyerId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "wallet",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.Buyer",
        name: "buyer",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "BuyerCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "buyerId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "wallet",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.Buyer",
        name: "buyer",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "BuyerUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "sellerId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.Seller",
        name: "seller",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.AuthTokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.AuthToken",
        name: "authToken",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "SellerUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "disputeResolverId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "escalationResponsePeriod",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "string",
            name: "metadataUri",
            type: "string",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.DisputeResolver",
        name: "disputeResolver",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "DisputeResolverUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "disputeResolverId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "escalationResponsePeriod",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "string",
            name: "metadataUri",
            type: "string",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.DisputeResolver",
        name: "disputeResolver",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "DisputeResolverActivated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "disputeResolverId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "escalationResponsePeriod",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "string",
            name: "metadataUri",
            type: "string",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.DisputeResolver",
        name: "disputeResolver",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "tokenAddress",
            type: "address",
          },
          {
            internalType: "string",
            name: "tokenName",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "feeAmount",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.DisputeResolverFee[]",
        name: "disputeResolverFees",
        type: "tuple[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "sellerAllowList",
        type: "uint256[]",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "DisputeResolverCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "disputeResolverId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "address",
            name: "tokenAddress",
            type: "address",
          },
          {
            internalType: "string",
            name: "tokenName",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "feeAmount",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.DisputeResolverFee[]",
        name: "disputeResolverFees",
        type: "tuple[]",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "DisputeResolverFeesAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "disputeResolverId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "feeTokensRemoved",
        type: "address[]",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "DisputeResolverFeesRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "disputeResolverId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "escalationResponsePeriod",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "string",
            name: "metadataUri",
            type: "string",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.DisputeResolver",
        name: "disputeResolver",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "escalationResponsePeriod",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "string",
            name: "metadataUri",
            type: "string",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.DisputeResolver",
        name: "pendingDisputeResolver",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "DisputeResolverUpdateApplied",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "disputeResolverId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "escalationResponsePeriod",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "string",
            name: "metadataUri",
            type: "string",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.DisputeResolver",
        name: "pendingDisputeResolver",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "DisputeResolverUpdatePending",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "sellerId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.Seller",
        name: "seller",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "address",
        name: "voucherCloneAddress",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.AuthTokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.AuthToken",
        name: "authToken",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "SellerCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "sellerId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.Seller",
        name: "seller",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.Seller",
        name: "pendingSeller",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.AuthTokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.AuthToken",
        name: "authToken",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.AuthTokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.AuthToken",
        name: "pendingAuthToken",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "SellerUpdateApplied",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "sellerId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.Seller",
        name: "pendingSeller",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.AuthTokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.AuthToken",
        name: "pendingAuthToken",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "SellerUpdatePending",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_disputeResolverId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "address",
            name: "tokenAddress",
            type: "address",
          },
          {
            internalType: "string",
            name: "tokenName",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "feeAmount",
            type: "uint256",
          },
        ],
        internalType: "struct BosonTypes.DisputeResolverFee[]",
        name: "_disputeResolverFees",
        type: "tuple[]",
      },
    ],
    name: "addFeesToDisputeResolver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_disputeResolverId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "_sellerAllowList",
        type: "uint256[]",
      },
    ],
    name: "addSellersToAllowList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_disputeResolverId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "_sellerIds",
        type: "uint256[]",
      },
    ],
    name: "areSellersAllowed",
    outputs: [
      {
        internalType: "bool[]",
        name: "sellerAllowed",
        type: "bool[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "feePercentage",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "wallet",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.Agent",
        name: "_agent",
        type: "tuple",
      },
    ],
    name: "createAgent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "wallet",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.Buyer",
        name: "_buyer",
        type: "tuple",
      },
    ],
    name: "createBuyer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "escalationResponsePeriod",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "string",
            name: "metadataUri",
            type: "string",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.DisputeResolver",
        name: "_disputeResolver",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "tokenAddress",
            type: "address",
          },
          {
            internalType: "string",
            name: "tokenName",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "feeAmount",
            type: "uint256",
          },
        ],
        internalType: "struct BosonTypes.DisputeResolverFee[]",
        name: "_disputeResolverFees",
        type: "tuple[]",
      },
      {
        internalType: "uint256[]",
        name: "_sellerAllowList",
        type: "uint256[]",
      },
    ],
    name: "createDisputeResolver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.Seller",
        name: "_seller",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.AuthTokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        internalType: "struct BosonTypes.AuthToken",
        name: "_authToken",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "string",
            name: "contractURI",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "royaltyPercentage",
            type: "uint256",
          },
        ],
        internalType: "struct BosonTypes.VoucherInitValues",
        name: "_voucherInitValues",
        type: "tuple",
      },
    ],
    name: "createSeller",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_agentId",
        type: "uint256",
      },
    ],
    name: "getAgent",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "feePercentage",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "wallet",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.Agent",
        name: "agent",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_buyerId",
        type: "uint256",
      },
    ],
    name: "getBuyer",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "wallet",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.Buyer",
        name: "buyer",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_disputeResolverId",
        type: "uint256",
      },
    ],
    name: "getDisputeResolver",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "escalationResponsePeriod",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "string",
            name: "metadataUri",
            type: "string",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.DisputeResolver",
        name: "disputeResolver",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "tokenAddress",
            type: "address",
          },
          {
            internalType: "string",
            name: "tokenName",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "feeAmount",
            type: "uint256",
          },
        ],
        internalType: "struct BosonTypes.DisputeResolverFee[]",
        name: "disputeResolverFees",
        type: "tuple[]",
      },
      {
        internalType: "uint256[]",
        name: "sellerAllowList",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_associatedAddress",
        type: "address",
      },
    ],
    name: "getDisputeResolverByAddress",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "escalationResponsePeriod",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "string",
            name: "metadataUri",
            type: "string",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.DisputeResolver",
        name: "disputeResolver",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "tokenAddress",
            type: "address",
          },
          {
            internalType: "string",
            name: "tokenName",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "feeAmount",
            type: "uint256",
          },
        ],
        internalType: "struct BosonTypes.DisputeResolverFee[]",
        name: "disputeResolverFees",
        type: "tuple[]",
      },
      {
        internalType: "uint256[]",
        name: "sellerAllowList",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getNextAccountId",
    outputs: [
      {
        internalType: "uint256",
        name: "nextAccountId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_sellerId",
        type: "uint256",
      },
    ],
    name: "getSeller",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.Seller",
        name: "seller",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.AuthTokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        internalType: "struct BosonTypes.AuthToken",
        name: "authToken",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_associatedAddress",
        type: "address",
      },
    ],
    name: "getSellerByAddress",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.Seller",
        name: "seller",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.AuthTokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        internalType: "struct BosonTypes.AuthToken",
        name: "authToken",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.AuthTokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        internalType: "struct BosonTypes.AuthToken",
        name: "_associatedAuthToken",
        type: "tuple",
      },
    ],
    name: "getSellerByAuthToken",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.Seller",
        name: "seller",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.AuthTokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        internalType: "struct BosonTypes.AuthToken",
        name: "authToken",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_disputeResolverId",
        type: "uint256",
      },
      {
        internalType: "enum BosonTypes.DisputeResolverUpdateFields[]",
        name: "_fieldsToUpdate",
        type: "uint8[]",
      },
    ],
    name: "optInToDisputeResolverUpdate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_sellerId",
        type: "uint256",
      },
      {
        internalType: "enum BosonTypes.SellerUpdateFields[]",
        name: "_fieldsToUpdate",
        type: "uint8[]",
      },
    ],
    name: "optInToSellerUpdate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_disputeResolverId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "_feeTokenAddresses",
        type: "address[]",
      },
    ],
    name: "removeFeesFromDisputeResolver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_disputeResolverId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "_sellerAllowList",
        type: "uint256[]",
      },
    ],
    name: "removeSellersFromAllowList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "feePercentage",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "wallet",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.Agent",
        name: "_agent",
        type: "tuple",
      },
    ],
    name: "updateAgent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "wallet",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.Buyer",
        name: "_buyer",
        type: "tuple",
      },
    ],
    name: "updateBuyer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "escalationResponsePeriod",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "string",
            name: "metadataUri",
            type: "string",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.DisputeResolver",
        name: "_disputeResolver",
        type: "tuple",
      },
    ],
    name: "updateDisputeResolver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "address",
            name: "admin",
            type: "address",
          },
          {
            internalType: "address",
            name: "clerk",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.Seller",
        name: "_seller",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.AuthTokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        internalType: "struct BosonTypes.AuthToken",
        name: "_authToken",
        type: "tuple",
      },
    ],
    name: "updateSeller",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IBosonAccountHandler__factory {
  static readonly abi = _abi;
  static createInterface(): IBosonAccountHandlerInterface {
    return new utils.Interface(_abi) as IBosonAccountHandlerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IBosonAccountHandler {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as IBosonAccountHandler;
  }
}
